module.exports = __webpack_public_path__ + "static/media/ardc-logo-notext.2290ec21.svg";